import { RuleObject } from 'antd/lib/form';
import dayjs from 'dayjs';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

export const daysAfterValidation = (days: number, diffDay?: string) => [
    {
        required: true,
        message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
    },
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (
                (dayjs(value).diff(dayjs(diffDay), 'days') > days && dayjs(value).diff(dayjs(), 'days') > days) ||
                !value
            )
                return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_DATUM_MENSI</TranslateText>);
        }
    })
];

export default daysAfterValidation;
